module.exports = "- Use them to represent list of selected people.\n"